<atx-input-date-range
  class="w-100"
  [minDate]="minDate$ | async"
  [range]="dateRange$ | async"
  [allowWriteValueReset]="true"
  [allowClear]="true"
  [formControl]="dateRangeControl"
></atx-input-date-range>
